module.exports = __webpack_public_path__ + "images/line_friend_lp/campaign-lead-text_410e0d4f05ab94a04305b528604ec9b7.png";